(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var sel = '[data-mp-reveal]';

  if (reduce || !('IntersectionObserver' in window)) {
    document.querySelectorAll(sel).forEach(function (el) { el.classList.add('mp-in'); });
    return;
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('mp-in'); io.unobserve(e.target); }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });

  function bind() {
    document.querySelectorAll(sel + ':not(.mp-bound)').forEach(function (el) {
      el.classList.add('mp-bound');
      io.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
  document.addEventListener('shopify:section:load', bind);
})();
